import $ from 'jquery';

export function clone(src) {
    let target = {};
    for (let prop in src) {
        if (src.hasOwnProperty(prop)) {
            target[prop] = src[prop];
        }
    }
    return target;
}

export function formatDate(date) {
    if (date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const day_val = (day < 10 ? ('0' + day) : '' + day);
        const month_val = (month < 10 ? ('0' + month) : '' + month);

        const formatted_val = day_val + '/' + month_val + '/' + year;
        console.log(formatted_val);
        return formatted_val;
    }
    return null;
}

export function formatDateDay(date) {
    if (date) {
        console.log(date);
        const day = date.getDate();
        // const day_val = (day < 10 ? ('0' + day) : '' + day);
        return day;
    }
    return null;
}

export function formatDateMonth(date) {
    var month_names = ["Январь", "Феврал", "Март",
        "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь",
        "Октябрь", "Ноябрь", "Декабрь"];
    var month_index = date.getMonth();
    return month_names[month_index];
}

export function formatDateWeek(date) {
    var days = ['Якшанба', 'Душанба', 'Сешанба', 'Чоршанба', 'Пайшанба', 'Жума', 'Шанба'];
    var dayName = days[date.getDay()];
    return dayName;
}

export function formatDateText(date) {
        var month_names = ["Январь", "Феврал", "Март",
        "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь",
        "Октябрь", "Ноябрь", "Декабрь"];

        var day = date.getDate();
        var month_index = date.getMonth();
        var year = date.getFullYear();

        return "" + day + "-" + month_names[month_index] + "-" + year;
}
export function format_date(date) {
    if (date ) {
        var date1 = new Date(date);
        return formatDate(date1);
    }
    return null;
}

export function parseDate(date_val) {
    if (date_val && date_val.length > 0) {
        const data = date_val.split('/');
        if (data && data.length === 3) {
            return new Date(data[2], data[1] - 1, data[0]);
        }
    }
    return null;
}

export function clickImage(val) {
    var list = document.getElementsByClassName("dz-image");
    for (var i = 0; i < list.length; i++) {
        var imgs = list[i].getElementsByTagName("img");
        var img = imgs[0];
        img.style.cursor = "pointer";
    }
    $(val+" > .dz-preview >.dz-details").css("display", "none");
    $(val).click(function (event) {
        if (event.target.nodeName === "IMG") {
            var $url = event.target.src;
            if ($url !== undefined && $url !== '') {
                window.open($url, '_blank');
            } else {
                window.open($(event.target).attr("url"), '_blank');
            }
        }
    });
}

export function findBy(items, by, value) {
    for (var i=0; i<items.length; i++){
        if(items[i][by]===value){
            return items[i];
        }
    }
}

export function updateDifferences(target, source) {
    for (const key in source) {

        if (
            typeof source[key] === "object" &&
            source[key] !== null &&
            !Array.isArray(source[key]) &&
            typeof target[key] === "object" &&
            target[key] !== null &&
            !Array.isArray(target[key])
        ) {
            if (key === 'wall' || key === 'electrical_devices' || key === 'architectural_style') {
                updateDifferences(target[key], source[key]);
            }
        }

        else if (Array.isArray(source[key])) {
            if (JSON.stringify(target[key]) !== JSON.stringify(source[key])) {
                target[key] = source[key];
            }
        }

        else {
            if (target[key] !== source[key]) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

export function updateDifferences2(target, source) {
    const fieldsToReplace = ["wall", "electrical_devices", "architectural_style"];
    fieldsToReplace.forEach(field => {
        if (source.values[field] !== undefined) {
            target.values[field] = source.values[field];
        }
    });

    return target;
}

export function addQueryParams(path, params) {
    const query = new URLSearchParams(params).toString();
    return query ? `${path}?${query}` : path;
}